import script from "./ActionBlockPreviewItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ActionBlockPreviewItem.vue?vue&type=script&lang=ts&setup=true"

import "./ActionBlockPreviewItem.vue?vue&type=style&index=0&id=c1c8889c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1c8889c"]])

export default __exports__